/**
 * The clock. ADR-006 §7 CAL-L3.
 *
 * `Date.now()` appears exactly once in this repository, below. That is not
 * pedantry: "posting on the last day of a period" is only testable if the
 * current time is something a test can set. Scattered through domain code,
 * `Date.now()` makes period-boundary behaviour depend on when CI happens to
 * run — which is a test that passes for eleven months and then does not.
 */
import { businessDateInZone, instantFromEpochMs } from './instant.js';
import { DEFAULT_DISPLAY_ZONE } from './instant.js';
/** The only place the ambient clock is read. */
export const systemClock = {
    now: () => instantFromEpochMs(Date.now()),
    today: (zone = DEFAULT_DISPLAY_ZONE) => businessDateInZone(instantFromEpochMs(Date.now()), zone),
};
/** A clock stopped at an instant. Tests and replay. */
export function fixedClock(at) {
    return {
        now: () => at,
        today: (zone = DEFAULT_DISPLAY_ZONE) => businessDateInZone(at, zone),
    };
}
/** A clock that advances only when told to. For stepping across a boundary. */
export function manualClock(start) {
    let current = start;
    return {
        now: () => current,
        today: (zone = DEFAULT_DISPLAY_ZONE) => businessDateInZone(current, zone),
        advance: (ms) => {
            current = instantFromEpochMs(current + ms);
        },
    };
}
//# sourceMappingURL=clock.js.map